module.exports = __webpack_public_path__ + "img/Leaguebuilding5.886fe490.png";